const WORKOUT_EXERCISES_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  CURRENT_SET_INDEX: 'currentSetIndex',
  DATA: 'data'
}

export default WORKOUT_EXERCISES_KEY
